"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _react = _interopRequireDefault(require("react"));
var _images = require("../common_features/assets/images");
var _reactBootstrap = require("react-bootstrap");
var _ai = require("react-icons/ai");
var _DataTable = require("@ccw-pwa-ui/DataTable");
var _Button = require("@ccw-pwa-ui/Button");
const ManageStoreComponent = props => {
  const {
    headerSchema,
    bodySchema,
    setAllSelected,
    allSelect,
    rowSelect,
    setRowSelected,
    currentPage,
    pageSize,
    handlePageChange,
    setSearch,
    selectedFilter,
    setSelectedFilter,
    navigate,
    setQuery,
    query,
    currentStoreSet,
    isDataLoading,
    setDataValuesToState,
    setIsDataLoading,
    serachUserType,
    handleOnKeyPress,
    dropdownList,
    disabled
  } = props;
  console.log("props.count:-", props.count);
  const addStoreString = {
    MAIN_CONTENT: props.userType === 4 ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, "Click on", /*#__PURE__*/_react.default.createElement(_Button.Button, {
      "data-testid": "AddStore",
      onClick: navigate,
      variant: "nav-link-button",
      icon: /*#__PURE__*/_react.default.createElement("img", {
        src: _images.Plus.default,
        style: {
          width: "80%"
        }
      }),
      type: "submit",
      title: "Add Store",
      buttonStyle: {
        width: "110px",
        marginLeft: "5px",
        padding: "2px"
      }
    }), "to add a store") : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, "Connect with Pentair TWM for more information")
  };
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "px-4"
  }, props.removeUserModal ? /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    negativeButtonActionTitle: props.negativeButtonActionTitle,
    positiveAction: props.handleResendInviteModal,
    positiveActionButtonTitle: props.positiveActionButtonTitle,
    variantBtn1: "outline-primary-long",
    variantBtn2: "nav-link-button",
    modalHeaderTextStyle: {
      fontSize: 20,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "25px"
    },
    wrapperStyle: {
      borderRadius: "12px 12px 12px 12px"
    },
    btn1Style: {
      color: "#E00932",
      borderColor: "#E00932"
    },
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    modalHeaderText: props.modalHeaderText,
    negativeAvtion: props.handleSetReInviteCancelModal,
    displayModal: props.removeUserModal,
    variant: "remove-user-modal",
    modalDetailText: props.modalDetailText,
    modalDetailText2: props.modalDetailText2,
    btn2Style: {
      width: '100%',
      justifyContent: "center"
    }
  }) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex flex-column align-items-start  p-0  pt-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    xs: true,
    sm: true,
    className: "d-flex flex-row  justify-content-between py-2 px-4 align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-row align-items-center"
  }, props.subHeading ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Manage Stores - ".concat(props.subHeading),
    variant: "header-text",
    headerStyle: {
      fontSize: 27,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "34px"
    }
  }) : /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Manage Stores",
    variant: "header-text",
    headerStyle: {
      fontSize: 27,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "34px"
    }
  })), serachUserType !== 7 ? /*#__PURE__*/_react.default.createElement(_Button.Button, {
    "data-testid": "AddStore",
    onClick: navigate,
    variant: "outline-primary",
    icon: /*#__PURE__*/_react.default.createElement("img", {
      src: _images.Plus.default,
      style: {
        width: "80%"
      }
    }),
    type: "submit",
    title: "Add Store",
    buttonStyle: {
      marginRight: 0
    }
  }) : "")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex flex-column align-items-start  p-0 pt-1"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    xs: true,
    sm: true,
    className: "d-flex flex-row align-items-center justify-content-between  px-4"
  }, allSelect || rowSelect && rowSelect.length && props.userType != 5 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, props.removeStore ? /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "nav-link-button",
    title: rowSelect.length <= 1 ? props.removeStore : "".concat(props.removeStore, "s"),
    buttonStyle: {
      fontSize: 16,
      color: '#E00932',
      fontWeight: 700,
      lineHeight: "24px",
      fontStyle: "normal",
      corsor: 'pointer'
    },
    icon: /*#__PURE__*/_react.default.createElement(_ai.AiFillDelete, {
      style: {
        fontSize: 16,
        color: '#E00932',
        fontWeight: 700,
        lineHeight: "24px",
        paddingBottom: -4
      }
    }),
    onClick: props.onClickRemove
  }) : null) : /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "You have " + props.count + "".concat(props.count <= 1 ? ' store' : ' stores', " "),
    variant: "simple-text",
    headerStyle: {
      fontSize: 12,
      fontWeight: 400,
      color: '#9a9a9a',
      lineHeight: '18px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "filter-search-box",
    onKeyPress: handleOnKeyPress,
    inputProps: {
      placeholder: "Search By filter",
      inputVal: setQuery,
      onchange: setQuery,
      disabled,
      suffix: /*#__PURE__*/_react.default.createElement(_ai.AiOutlineSearch, {
        "data-testid": "suffix",
        style: query ? {
          fontSize: 20,
          color: '#333333',
          cursor: "pointer"
        } : {
          fontSize: 16,
          color: '#9A9A9A'
        },
        onClick: e => {
          setSearch(query);
          setIsDataLoading(true);
          setDataValuesToState();
        }
      })
    },
    selectProps: {
      dropdownList: dropdownList,
      itemClick: setSelectedFilter,
      selectedItem: selectedFilter.value,
      placeholder: "Please select filter"
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, {
    checkboxPosition: props.checkboxPosition,
    allowRowClick: true,
    activeRowStyle: {
      background: 'transparent',
      cursor: 'pointer'
    },
    isReponsive: true,
    isHover: true,
    handleRowClick: (e, result) => {
      currentStoreSet(result);
    },
    headerSchema: headerSchema,
    bodySchema: bodySchema,
    handleAllRowSelected: setAllSelected,
    allRowSelected: allSelect,
    rowSelectedList: rowSelect,
    handleRowSelect: setRowSelected,
    isLoading: isDataLoading,
    paginationProps: {
      totalLength: props.count,
      currentPage: currentPage,
      pageSize: pageSize,
      handlePageChange: handlePageChange,
      paginationStyle: {
        float: "right"
      }
    },
    loadingDataProps: {
      headingTitle: "Loading...",
      headerDesc: "Loading data, please wait"
    },
    noDataProps: {
      headingTitle: props.userType === 4 ? "No Stores Added" : "No Stores Assigned",
      headerDesc: addStoreString.MAIN_CONTENT
    }
  }), !props.subHeading && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      zIndex: 9999,
      position: "fixed",
      top: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      backdropFilter: "blur(1px)",
      background: "rgba(255,255,255,0.2)"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  }))))));
  // : <div className='d-flex justify-content-center '><h1>Loading...</h1></div>
};
var _default = exports.default = ManageStoreComponent;